import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Pin"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21.4425 9.9825L22.5 8.925L15 1.5L14.0175 2.565L14.9025 3.45L6.285 10.74L4.995 9.4575L3.9375 10.5L8.1825 14.76L1.5 21.435L2.5575 22.5L9.24 15.8175L13.5 20.0625L14.5425 18.9975L13.26 17.715L20.55 9.0975L21.4425 9.9825ZM12.195 16.65L7.35005 11.805L15.9675 4.5L19.5 8.0325L12.195 16.65Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Pin.vue"]]);
